export const createReactHybridPageRegistry = () => {
  const pageTemplatesRegistry: string[] = [];

  function register(templateName: string) {
    pageTemplatesRegistry.push(templateName);
  }

  function isTemplateRegistered(pageProps: any) {
    const id = getUniformPageTemplateName(pageProps);
    return pageTemplatesRegistry.includes(id);
  }

  function getUniformPageTemplateName(pageProps: any) {
    return pageProps?.page?.template;
  }

  return { register, isTemplateRegistered };
};
